import { MouseEventHandler } from "react";

export type UserMenuComponentProps = {
    /** Nadpis sekce */
    title: string;
    /** Uživatelské jméno */
    userName?: string;
    /** Funkce pro otevření fromuláře po kliknutí na hlavičku menu  */
    onMenuTitleClick: MouseEventHandler;
};
